<div class="modal-backdrop" *ngIf="aberto">
  <div class="modal-content">
    <button class="close-btn" (click)="fecharModal()" aria-label="Fechar">
      ×
    </button>
    <div class="modal-header">
      <div class="header-main">
        <div class="empresa-nome destaque-nome">{{ empresa?.nome || "-" }}</div>
        <div
          class="empresa-fantasy destaque-fantasy"
          *ngIf="empresa?.nome_fantasia"
        >
          {{ empresa?.nome_fantasia }}
        </div>
        <div class="badges-row">
          <span *ngIf="empresa?.plano?.nome" class="badge-status badge-plano"
            ><i class="icofont icofont-badge"></i>
            {{ empresa?.plano?.nome }}</span
          >
          <span *ngIf="diasRestantesTexto" [ngClass]="planoStatusClass"
            ><i class="icofont icofont-meeting-add"></i>
            {{ diasRestantesTexto }}</span
          >
        </div>
      </div>
      <div class="status-row">
        <span [ngClass]="planoStatusClass + ' badge-status-status'">{{
          planoStatusLabel
        }}</span>
      </div>
    </div>
    <div class="modal-body">
      <div class="bloco-info">
        <div class="bloco-titulo">
          <i class="feather icon-briefcase"></i> Dados da Empresa
        </div>
        <div class="info-row">
          <div class="info-item">
            <i class="feather icon-file-text"></i>
            <span class="label">CNPJ:</span>
            <span class="value">{{ empresa?.cnpj || "-" }}</span>
          </div>
          <div class="info-item">
            <i class="feather icon-percent"></i>
            <span class="label">Comissão:</span>
            <span class="value">{{
              empresa?.comissao_representante ?? "-"
            }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <i class="feather icon-map-pin"></i>
            <span class="label">Localização:</span>
            <span class="value"
              >{{ empresa?.cidade || "-" }}/{{ empresa?.uf || "-" }}</span
            >
          </div>
          <div class="info-item">
            <i class="feather icon-phone"></i>
            <span class="label">Telefone:</span>
            <span class="value">{{ empresa?.telefone || "-" }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item full-width">
            <i class="feather icon-mail"></i>
            <span class="label">Email:</span>
            <span class="value">{{ empresa?.email || "-" }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item full-width">
            <i class="feather icon-map-pin"></i>
            <span class="label">Endereço:</span>
            <span class="value">
              <ng-container
                *ngIf="
                  empresa?.rua || empresa?.numero || empresa?.bairro;
                  else enderecoNaoInformado
                "
              >
                {{ empresa?.rua || "-" }}, {{ empresa?.numero || "-" }} -
                {{ empresa?.bairro || "-" }}
                <div *ngIf="empresa?.cep" class="cep-line">
                  <i class="feather icon-mail"></i>
                  CEP: {{ empresa?.cep }}
                </div>
              </ng-container>
              <ng-template #enderecoNaoInformado>
                <span class="text-muted">
                  <i class="feather icon-alert-circle"></i>
                  Endereço não informado
                </span>
              </ng-template>
            </span>
          </div>
        </div>
      </div>
      <div class="bloco-info">
        <div class="bloco-titulo">
          <i class="icofont icofont-badge"></i> Plano
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">Plano:</span>
            <span class="value">
              {{ empresa?.plano?.nome || "-" }}
              <ng-container *ngIf="empresa?.plano?.valor">
                (R$ {{ empresa?.plano?.valor }})</ng-container
              >
            </span>
          </div>
          <div class="info-item">
            <span class="label">Expiração Do Plano:</span>
            <span class="value">{{
              empresa?.plano?.expiracao | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item comissao-destaque">
            <span class="label">Comissão do Representante:</span>
            <span class="value">{{ valorComissao }}</span>
          </div>
        </div>
      </div>
      <div class="bloco-info">
        <div class="bloco-titulo">
          <i class="icofont icofont-cur-dollar"></i> Pagamento
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">Último Pagamento:</span>
            <span class="value">
              <ng-container
                *ngIf="empresa?.ultimo_pagamento?.valor; else semPagamento"
              >
                R$ {{ empresa?.ultimo_pagamento?.valor }} -
                {{ empresa?.ultimo_pagamento?.status || "-" }}
              </ng-container>
              <ng-template #semPagamento>-</ng-template>
            </span>
          </div>
          <div class="info-item">
            <span class="label">Forma de Pagamento:</span>
            <span class="value">{{
              empresa?.ultimo_pagamento?.forma_pagamento || "-"
            }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-item">
            <span class="label">Data Do Pagamento:</span>
            <span class="value">{{
              empresa?.ultimo_pagamento?.data_pagamento | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
